module.exports = __webpack_public_path__ + "static/img/2.c7e1505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/equipment/forgeShop/2.png
// module id = Is9B
// module chunks = 13